










































































import { Component, Vue } from "vue-property-decorator";
import _ from "lodash";
import { Shift } from "@/api";
import ShiftForm from "@/views/admin/shift/ShiftForm.vue";
import loading from "@/components/loader/loading.vue";

@Component({
  components: { ShiftForm, loading },
})
export default class ShiftList extends Vue {
  search = "";
  dialog = false;
  count = 0;
  isDataLoading = false;

  async created() {
    this.isDataLoading = true;
    await this.$store.dispatch("shift/fetchShifts");
    this.isDataLoading = false;
  }

  get shifts(): Shift[] {
    const shifts = this.$store.getters["shift/shifts"];
    return shifts || [];
  }

  get filteredShifts(): Shift[] {
    const search = !this.search ? "" : this.search.toLowerCase();
    const list = _.sortBy(
      _.filter(this.shifts, (shift: Shift) =>
        _.includes(`${shift.shift.toLowerCase()}`, search),
      ),
      [(shift: Shift) => `${shift.shift.trim().toUpperCase()}`],
    );
    return list;
  }

  selectShift(shift: Shift) {
    this.$router.push({
      path: `/admin/shift/${shift.id}`,
    });
  }

  clearSearch() {
    this.search = "";
  }

  get shiftId(): number {
    const shiftIdParam = this.$route.params.id as string;
    if (shiftIdParam) {
      try {
        return parseInt(shiftIdParam);
      } catch (e) {
        return 0;
      }
    }
    return 0;
  }

  back() {
    this.$router.back();
  }

  formatTime(time: string): string {
    if (!time) return "";
    // Check if it's already a Date string or just HH:mm
    if (time.includes("T")) {
      const date = new Date(time);
      return date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
    }
    return time;
  }
}
